import { render, staticRenderFns } from "./PcWorksheetSection.vue?vue&type=template&id=42dacdb4"
import script from "./PcWorksheetSection.vue?vue&type=script&lang=js"
export * from "./PcWorksheetSection.vue?vue&type=script&lang=js"
import style0 from "./PcWorksheetSection.vue?vue&type=style&index=0&id=42dacdb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports